import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import OpenApiCatalogsPage from "./ui";

const OpenApiCatalogs = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <OpenApiCatalogsPage />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default OpenApiCatalogs;
